import { useState } from 'react'

import SelectWithLabeledValue, { SelectOption } from '@components/SelectWithLabeledValue'
import { ShortlistProfilePriority } from '@modules/shortlist/types'
import { MenuItem, Typography } from '@mui/material'

import { LabelContainer, PriorityStatusDot } from './index.styles'

interface SelectPriorityProps {
  label: string
  priority?: ShortlistProfilePriority
  priorityOptions: SelectOption[]
  onSelect: (priority: ShortlistProfilePriority) => void
}

const SelectPriority = ({ priority, priorityOptions, onSelect, label }: SelectPriorityProps) => {
  const [localValue, setLocalValue] = useState<number | undefined>()

  const handleSelect = (id: number) => {
    setLocalValue(id)
    onSelect(id as unknown as ShortlistProfilePriority)
  }

  return (
    <SelectWithLabeledValue
      label={label}
      width="100%"
      onSelect={handleSelect}
      options={priorityOptions}
      renderSelectedState={(option: SelectOption) => (
        <LabelContainer>
          <PriorityStatusDot $color={(option.data as { color: string })?.color} />
          {option.label}
        </LabelContainer>
      )}
      selectedOptionId={localValue || priority}
      renderOption={(option: SelectOption) => (
        <MenuItem key={option.id} value={option.id} disabled={option.id === priority} divider={option.divider}>
          <PriorityStatusDot $color={(option.data as { color: string })?.color} />
          <Typography variant="body1">{option.label}</Typography>
        </MenuItem>
      )}
    />
  )
}

export default SelectPriority
